import React from "react";
import {Container} from "react-bootstrap";

const ErrorPage = props => {
    return (
        <Container>
            <>
                <br />
                <br/>

                    <p>An unexpected error occurred. Please try again.
                    </p>


                    <br/><br/><br/><br/>


            </>
        </Container>
    );
}

export default ErrorPage;